module.exports = __webpack_public_path__ + "static/media/mobile7.b16eb7b3.png";